package ru.it_mozaika.sender.common.models

import kotlinx.serialization.Serializable

@Serializable
data class NamedItem(
    val id: String,
    val name: String
)